import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useLocation, NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";

import LanguageSwitcher from "./components/LanguageSwitcher";
import styles from "./Register.module.css";

const API_URL = process.env.REACT_APP_API_URL;
const PAGE_BG = `${process.env.PUBLIC_URL}/fon.png`;
const HEADER_BG = `${process.env.PUBLIC_URL}/headerShapka.png`;

export default function Register() {
  const { t } = useTranslation();



  useEffect(() => {
  let viewport = document.querySelector('meta[name="viewport"]');
  const oldContent = viewport?.getAttribute("content") || null;
  const created = !viewport;

  if (!viewport) {
    viewport = document.createElement("meta");
    viewport.setAttribute("name", "viewport");
    document.head.appendChild(viewport);
  }

  viewport.setAttribute(
    "content",
    "width=device-width, initial-scale=1, viewport-fit=cover"
  );

  return () => {
    if (created) {
      viewport.remove();
    } else if (oldContent !== null) {
      viewport.setAttribute("content", oldContent);
    }
  };
}, []);
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPass, setShowPass] = useState(false);

  const [errorUser, setErrorUser] = useState("");
  const [errorPass, setErrorPass] = useState("");
  const [error, setError] = useState("");

  const navigate = useNavigate();
  const location = useLocation();

  const refCode = useMemo(() => {
    try {
      const params = new URLSearchParams(location.search);
      return (params.get("ref") || "").toString().trim();
    } catch {
      return "";
    }
  }, [location.search]);

  function validateUsername(name) {
    if (name.length < 3) {
      return t("auth.validation.usernameMin");
    }

    if (name.length > 9) {
      return t("auth.validation.usernameMax");
    }

    if (!/^[A-Za-zА-Яа-яЁё0-9]+$/.test(name)) {
      return t("auth.validation.usernameChars");
    }

    return "";
  }

  function validatePassword(pass) {
    if (pass.length < 6) {
      return t("auth.validation.passwordMin");
    }

    if (!/[A-Za-z]/.test(pass)) {
      return t("auth.validation.passwordLatin");
    }

    if (/[А-Яа-яЁё]/.test(pass)) {
      return t("auth.validation.passwordCyrillic");
    }

    return "";
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");

    const userErr = validateUsername(username);
    const passErr = validatePassword(password);

    setErrorUser(userErr);
    setErrorPass(passErr);

    if (userErr || passErr) {
      return;
    }

    try {
      const payload = {
        username,
        email,
        password,
      };

      if (refCode) {
        payload.ref = refCode;
      }

      const { data } = await axios.post(
        `${API_URL}/api/auth/register`,
        payload
      );

      localStorage.setItem("token", data.token);
      localStorage.setItem("username", data.user.username);
      localStorage.setItem("bgq_onboarding_start", "1");

      navigate("/");
      window.location.reload();
    } catch (err) {
      setError(
        err?.response?.data?.error ||
          t("auth.errors.registration")
      );
    }
  }

  return (
    <div
      className={styles.page}
      style={{
        backgroundImage: `
          radial-gradient(
            900px 520px at 72% 12%,
            rgba(202,162,79,.08),
            transparent 60%
          ),
          radial-gradient(
            780px 520px at 20% 85%,
            rgba(79,167,230,.08),
            transparent 60%
          ),
          url(${PAGE_BG})
        `,
        backgroundRepeat:
          "no-repeat, no-repeat, no-repeat",
        backgroundSize:
          "auto, auto, cover",
        backgroundPosition:
          "center top, center bottom, center top",
      }}
    >
      <div
        className={styles.authAnimatedBg}
        aria-hidden="true"
      />

      <header
        className={styles.header}
        style={{
          backgroundImage: `url(${HEADER_BG})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className={styles.headerInner}>
          <NavLink
            to="/"
            className={styles.logo}
          >
            <span className={styles.logoMain}>
              BACKGAMMON
            </span>

            <span className={styles.logoAccent}>
              QUEST
            </span>
          </NavLink>

          <nav
            className={styles.menu}
            aria-label={t("auth.mainMenuAria")}
          >
            <NavLink
              to="/nardy"
              className={({ isActive }) =>
                `${styles.menuItem} ${
                  isActive
                    ? styles.menuItemActive
                    : ""
                }`
              }
            >
              {t("header.backgammon")}
            </NavLink>

            <NavLink
              to="/quests"
              className={({ isActive }) =>
                `${styles.menuItem} ${
                  isActive
                    ? styles.menuItemActive
                    : ""
                }`
              }
            >
              {t("header.quests")}
            </NavLink>

            <NavLink
              to="/poker"
              className={({ isActive }) =>
                `${styles.menuItem} ${
                  isActive
                    ? styles.menuItemActive
                    : ""
                }`
              }
            >
              {t("header.poker")}
            </NavLink>

            <NavLink
              to="/satellites"
              className={({ isActive }) =>
                `${styles.menuItem} ${
                  isActive
                    ? styles.menuItemActive
                    : ""
                }`
              }
            >
              {t("header.satellites")}
            </NavLink>
          </nav>

          <div className={styles.headerButtons}>
            <div className={styles.languageSlot}>
              <LanguageSwitcher />
            </div>

            <button
              type="button"
              className={styles.loginButton}
              onClick={() => navigate("/login")}
            >
              {t("header.login")}
            </button>

            <button
              type="button"
              className={styles.registerButton}
              onClick={() => navigate("/register")}
            >
              {t("header.register")}
            </button>
          </div>
        </div>
      </header>

      <main className={styles.authPage}>
        <div className={styles.card}>
          <div className={styles.brandBar}>
            BACKGAMMON QUEST
          </div>

          <form
            className={styles.form}
            onSubmit={handleSubmit}
          >
            <h2 className={styles.title}>
              {t("auth.registerTitle")}
            </h2>

            <div className={styles.group}>
              <label htmlFor="register-username">
                {t("auth.username")}
              </label>

              <input
                id="register-username"
                type="text"
                value={username}
                placeholder={t(
                  "auth.usernamePlaceholder"
                )}
                onChange={(e) => {
                  setUsername(e.target.value);
                  setErrorUser(
                    validateUsername(
                      e.target.value
                    )
                  );
                }}
              />

              {errorUser ? (
                <div className={styles.error}>
                  {errorUser}
                </div>
              ) : null}
            </div>

            <div className={styles.group}>
              <label htmlFor="register-email">
                {t("auth.email")}
              </label>

              <input
                id="register-email"
                type="email"
                value={email}
                placeholder={t(
                  "auth.emailPlaceholder"
                )}
                onChange={(e) =>
                  setEmail(e.target.value)
                }
                autoComplete="email"
              />
            </div>

            <div className={styles.group}>
              <label htmlFor="register-password">
                {t("auth.password")}
              </label>

              <div className={styles.passwordWrap}>
                <input
                  id="register-password"
                  type={
                    showPass
                      ? "text"
                      : "password"
                  }
                  value={password}
                  placeholder={t(
                    "auth.registerPasswordPlaceholder"
                  )}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    setErrorPass(
                      validatePassword(
                        e.target.value
                      )
                    );
                  }}
                  autoComplete="new-password"
                />

                <button
                  type="button"
                  className={styles.passwordToggle}
                  onClick={() =>
                    setShowPass(
                      (prev) => !prev
                    )
                  }
                  aria-label={
                    showPass
                      ? t("auth.hidePassword")
                      : t("auth.showPassword")
                  }
                >
                  {showPass
                    ? "👁️"
                    : "👁️‍🗨️"}
                </button>
              </div>

              {errorPass ? (
                <div className={styles.error}>
                  {errorPass}
                </div>
              ) : null}
            </div>

            {error ? (
              <div className={styles.error}>
                {error}
              </div>
            ) : null}

            <div className={styles.actions}>
              <button
                type="submit"
                className={styles.primary}
              >
                {t("auth.createAccount")}
              </button>

              <button
                type="button"
                className={styles.secondary}
                onClick={() =>
                  navigate("/login")
                }
              >
                {t("auth.signIn")}
              </button>
            </div>

            <div className={styles.subLinks}>
              <button
                type="button"
                className={styles.linkBtn}
                onClick={() =>
                  navigate(
                    "/forgot-password"
                  )
                }
              >
                {t("auth.forgotPassword")}
              </button>
            </div>
          </form>
        </div>
      </main>
    </div>
  );
}
